/** AUTO GENERATED FROM "node ./src/utils/build-icons.js". DO NOT TOUCH. * */
import React from 'react';
import classNames from 'classnames';

class Icon extends React.PureComponent {
  render() {
    const { className, svgRef, ...otherProps } = this.props;
    return (
      <svg
        width="66.15"
        height="95.58"
        viewBox="0 0 66.15 95.58"
        fill="currentColor"
        className={classNames('nmx-icon', className)}
        ref={svgRef}
        {...otherProps}>
        <path
          fill="#ffb81c"
          d="M8.28 88.13c0-13.67 11.13-22.89 24.8-22.89s24.8 9.22 24.8 22.89M52 39.59a100.67 100.67 0 0 0-37.8 0 25.29 25.29 0 0 0 35.71 2 24.54 24.54 0 0 0 2-2Z"
          className="icon-fill icon-accent"
          fillRule="evenodd"/>
        <path
          fill="#fff"
          d="M64.9 0H1.28A1.25 1.25 0 0 0 .03 1.25V7.5a1.25 1.25 0 0 0 1.25 1.25h63.65a1.25 1.25 0 0 0 1.25-1.25V1.29a1.25 1.25 0 0 0-1.2-1.3Zm-1.25 2.5v3.7H2.5V2.5Z"
          className="icon-fill icon-base"/>
        <path
          fill="#fff"
          d="M8.28 6.2a1.26 1.26 0 0 1 1.25 1.12v16.51a22.94 22.94 0 0 0 20 22.72 1.25 1.25 0 0 1-.32 2.48 25.42 25.42 0 0 1-22.2-24.81V7.5a1.24 1.24 0 0 1 1.18-1.3ZM57.87 6.7a1.26 1.26 0 0 1 1.25 1.12v16A25.44 25.44 0 0 1 36.9 49.03a1.25 1.25 0 0 1-.31-2.48 22.93 22.93 0 0 0 20-22.35V7.95a1.25 1.25 0 0 1 1.25-1.25ZM64.9 86.88H1.28a1.25 1.25 0 0 0-1.25 1.25v6.16a1.25 1.25 0 0 0 1.25 1.25h63.65a1.25 1.25 0 0 0 1.25-1.25v-6.2a1.25 1.25 0 0 0-1.28-1.21Zm-1.25 2.5v3.7H2.5v-3.7Z"
          className="icon-fill icon-base"/>
        <path
          fill="#fff"
          d="M29.28 46.55a1.26 1.26 0 0 1 1.4 1.09 1.24 1.24 0 0 1-1.07 1.39 22.92 22.92 0 0 0-20 22.35v16.75a1.25 1.25 0 0 1-1.28 1.22 1.24 1.24 0 0 1-1.21-1.09V71.75a25.44 25.44 0 0 1 22.16-25.2ZM36.9 46.55a25.44 25.44 0 0 1 22.22 24.82v16.76a1.25 1.25 0 0 1-1.28 1.22 1.24 1.24 0 0 1-1.21-1.09V71.75a23 23 0 0 0-20-22.72 1.27 1.27 0 1 1 .15-2.53Z"
          className="icon-fill icon-base"/>
        <path
          fill="#ffb81c"
          d="M34.48 50.85a1.41 1.41 0 1 1-1.41-1.41 1.41 1.41 0 0 1 1.41 1.41M34.48 55.9a1.41 1.41 0 1 1-1.42-1.4 1.41 1.41 0 0 1 1.41 1.41M34.48 60.95a1.41 1.41 0 1 1-1.41-1.45 1.41 1.41 0 0 1 1.41 1.45"
          className="icon-fill icon-accent"
          fillRule="evenodd"/>
      </svg>

    );
  }
}

Icon.displayName = 'HourglassIcon';

export default Icon;
